import { OnInit, ChangeDetectorRef } from '@angular/core';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { Constants } from '../../../shared/config/constants.config';
import { Router } from '@angular/router';
import { UsersService } from '../../../shared/services/users.service';
import { forkJoin } from 'rxjs';
import { ProductsService } from '../../../shared/services/products.service';
var UserPreferredProductsComponent = /** @class */ (function () {
    function UserPreferredProductsComponent(changeDetectorRef, usersService, appIsLoadingEventsEmitter, constants, productsService, router) {
        this.changeDetectorRef = changeDetectorRef;
        this.usersService = usersService;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.constants = constants;
        this.productsService = productsService;
        this.router = router;
        this.selectedPreferredProducts = [];
        this.productsByCategory = {};
        this.categories = [];
    }
    UserPreferredProductsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.productsService.getAllProducts(), this.productsService.getProductAllCategories(), this.usersService.getUserPreferredProducts()).subscribe(function (_a) {
            var products = _a[0], categories = _a[1], userPreferredProducts = _a[2];
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.categories = categories.sort(function (a, b) { return a.sort_in_user - b.sort_in_user; });
            products.map(function (product, index) {
                // @ts-ignore
                if (typeof _this.productsByCategory[product.category.id] === 'undefined') {
                    // @ts-ignore
                    _this.productsByCategory[product.category.id] = [];
                }
                // @ts-ignore
                _this.productsByCategory[product.category.id].push(product);
            });
            userPreferredProducts.map(function (preferredProduct, index) {
                _this.selectedPreferredProducts.push(preferredProduct.product.id);
            });
            _this.changeDetectorRef.detectChanges();
        });
    };
    UserPreferredProductsComponent.prototype.addProductToPreferred = function (product) {
        if (this.isProductPreferred(product)) {
            this.selectedPreferredProducts.splice(this.selectedPreferredProducts.indexOf(product.id), 1);
        }
        else {
            this.selectedPreferredProducts.push(product.id);
        }
        this.changeDetectorRef.markForCheck();
    };
    UserPreferredProductsComponent.prototype.isProductPreferred = function (product) {
        for (var _i = 0, _a = this.selectedPreferredProducts; _i < _a.length; _i++) {
            var productId = _a[_i];
            // @ts-ignore
            // tslint:disable-next-line:radix
            if (productId === parseInt(product.id)) {
                return true;
            }
        }
        return false;
    };
    UserPreferredProductsComponent.prototype.updateUserPreferredProducts = function () {
        var _this = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.changeDetectorRef.detectChanges();
        this.usersService.setUserPreferredProducts(this.selectedPreferredProducts).subscribe(function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.detectChanges();
        }, function () {
            _this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.detectChanges();
        });
    };
    return UserPreferredProductsComponent;
}());
export { UserPreferredProductsComponent };
